module.exports = __webpack_public_path__ + "img/imac.ff3f1245.svg";